import fetch from "node-fetch";

export default class {
  async getPlayerDetails({ id }) {
    const res = await fetch(
      `${process.env.API_URL}/players/${id}/GetPlayerDetails`,
      { headers: { "x-version": 2 } }
    );
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }

  async getPlayerStatistics({ id, season }) {
    const res = await fetch(
      `${process.env.API_URL}/players/${id}/GetPlayerStatistics?${
        season ? `season=${season}&` : "season=-1&"
      }`,
      { headers: { "x-version": 2 } }
    );

    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }

  async getSeasons({ id }) {
    const res = await fetch(
      `${process.env.API_URL}/players/${id}/GetPlayerSeasons`,
      { headers: { "x-version": 2 } }
    );
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }

  async getPlayerHistory({ id }) {
    const res = await fetch(
      `${process.env.API_URL}/players/${id}/GetPlayerHistory`,
      { headers: { "x-version": 2 } }
    );
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }
}
